"use client"
import dynamic from 'next/dynamic';
import { useBrowser } from '@/hooks/useBrowser';

const DefaultMobileSide = dynamic(
  () => import('./MobileSide').then((mod) => mod.MobileSide),
  {
    ssr: false,
    loading: () => null,
  },
);

interface MobileDetectProps extends React.PropsWithChildren {
  MobileSideComponent?: React.ComponentType<any>
}
export const MobileDetect = ({
  children,
  MobileSideComponent = DefaultMobileSide,
}: MobileDetectProps) => {
  const browser = useBrowser();

  if (!browser) {
    return children ?? null;
  }
  if (browser.parsePlatform().type === 'mobile') {
    const mobileSide = <MobileSideComponent />;

    if (!children) {
      return (
        <div className="fixed inset-0 z-[999] bg-background">
          {mobileSide}
        </div>
      );
    }

    return mobileSide;
  }

  return children ?? null;
};
